import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";
import { useLang } from "@/context/LanguageContext";

const DRIVER_IMG =
  "https://images.pexels.com/photos/17377416/pexels-photo-17377416.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=940";

export default function About() {
  const { t } = useLang();
  const a = t.about;

  return (
    <div className="relative z-10 bg-[#050505]" data-testid="about-page">
      {/* Intro */}
      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-40 pb-20 md:pb-28">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
          className="text-xs tracking-[0.25em] text-[#FF3B30] font-medium mb-8"
          data-testid="about-eyebrow"
        >
          {a.eyebrow}
        </motion.p>
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <motion.h1
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-8 font-display font-black tracking-tighter text-5xl sm:text-7xl lg:text-8xl leading-[0.9] text-white/95"
          >
            {a.title}
          </motion.h1>
          <Reveal delay={0.2} className="lg:col-span-4">
            <p className="text-white/55 text-lg leading-relaxed">{a.intro}</p>
          </Reveal>
        </div>
      </section>

      {/* Image band */}
      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-24 md:pb-32">
        <Reveal className="relative overflow-hidden rounded-3xl">
          <div className="aspect-[21/9] w-full overflow-hidden">
            <img src={DRIVER_IMG} alt="Aportta driver" className="w-full h-full object-cover" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
        </Reveal>
      </section>

      {/* Manifesto chapters */}
      <section className="max-w-[1400px] mx-auto px-5 sm:px-8 pb-32 md:pb-44">
        <div className="flex flex-col">
          {a.chapters.map((c, i) => (
            <Reveal
              key={c.no}
              delay={0}
              className="group grid md:grid-cols-12 gap-6 md:gap-10 py-12 md:py-16 border-t border-white/10"
            >
              <div className="md:col-span-3">
                <span className="font-display font-black text-6xl md:text-7xl text-white/10 group-hover:text-[#FF3B30] transition-colors duration-500">
                  {c.no}
                </span>
              </div>
              <h3 className="md:col-span-4 font-display font-bold text-3xl md:text-4xl text-white/95 tracking-tight">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-white/55 text-lg leading-relaxed">{c.text}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
